export const CIAN_ADV_LINK =
    'https://www.cian.ru/ipoteka-main/?utm_source=sravni&utm_medium=cpa&utm_campaign=sravni_zayavka&utm_content=cian_ipoteka_from_zayavka&utm_term=ipoteka_06&sravni_id=%7Btransaction_id%7D';

export const CIAN_ADV_LINK_B =
    'https://www.cian.ru/ipoteka-main/?utm_source=sravni&utm_medium=cpa&utm_campaign=sravni_zayavka&utm_content=cian_ipoteka_from_zayavka_b&utm_term=ipoteka_06&sravni_id=%7Btransaction_id%7D';
